// /axios/AxiosInterceptor.ts
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { EnvConfigs } from '../lib/config';

const axiosInstance: AxiosInstance = axios.create({
    baseURL: EnvConfigs.REACT_APP_API_URL + EnvConfigs.version, // Ensure your API base URL is set in your .env file
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('BookezToken'); // Get the correct token from sessionStorage

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error: AxiosError) => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// === Response Interceptor ===
axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        return response.data;
    },
    (error: AxiosError) => {
        // Optional: global error logging
        console.error('Response Error:', error);

        // Auto logout on 401
        // if (error.response?.status === 401) {
        //     localStorage.clear();
        //     window.location.href = '/login'; // Or use navigation logic if in SPA
        // }

        return Promise.reject(error);
    }
);

export default axiosInstance;
